import { Card, CrudMode, DataDisplay, pn, Stack, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { Input } from "components";
import { NonPersonnel, NonPersonnelEditResource, NonPersonnelViewResource, Permission } from "generated/openApi";

import produce from "immer";
import "moment-timezone";
import { AmountsInfo } from "./AmountsInfo";
import { MainInfo } from "./MainInfo";
import { NonPersonnelFiles } from "./NonPersonnelFiles/NonPersonnelFiles";

export const NonPersonnelPageBody = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  nonPersonnel: NonPersonnel;
  setNonPersonnel: (value: NonPersonnel) => void;
  viewResource: NonPersonnelViewResource;
  editResource: NonPersonnelEditResource;
  validationErrors: ValidationErrors;
  onEdit: () => void;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const noteField = () => {
    const propertyName = pn<NonPersonnel>("note");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName} type="textarea">
        {props.nonPersonnel.note}
      </DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        multiline
        value={props.nonPersonnel.note}
        onChange={(e) =>
          props.setNonPersonnel(
            produce(props.nonPersonnel, (draft) => {
              draft.note = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Stack direction="column" spacing="lg">
      <Card header={"Info"}>
        <Stack ref={breakpointsRef} direction="column" spacing="lg">
          <MainInfo
            id={props.nonPersonnel.id}
            crudMode={props.crudMode}
            nonPersonnel={props.nonPersonnel}
            setNonPersonnel={props.setNonPersonnel}
            viewResource={props.viewResource}
            editResource={props.editResource}
            validationErrors={props.validationErrors}
          />

          <AmountsInfo
            crudMode={props.crudMode}
            nonPersonnel={props.nonPersonnel}
            setNonPersonnel={props.setNonPersonnel}
            viewResource={props.viewResource}
            editResource={props.editResource}
            validationErrors={props.validationErrors}
          />

          {noteField()}

          <NonPersonnelFiles
            rootPermission={props.rootPermission}
            id={props.nonPersonnel.id}
            nonPersonnelFiles={props.nonPersonnel.files || []}
            setNonPersonnelFiles={(files) => {
              props.setNonPersonnel(
                produce(props.nonPersonnel, (draft) => {
                  draft.files = files;
                })
              );
              props.onEdit();
            }}
          />
        </Stack>
      </Card>
    </Stack>
  );
};
